import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#currentColor",
      "fill-rule": "evenodd",
      d: "M0 13a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1m0-6a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1m0-6a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }